import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import Navbar from "@/components/home/Navbar";
import Hero from "@/components/home/Hero";
import Marquee from "@/components/home/Marquee";
import Stations from "@/components/home/Stations";
import PnrLookup from "@/components/home/PnrLookup";
import ThaliOrder from "@/components/home/ThaliOrder";
import Footer from "@/components/home/Footer";

export default function Home() {
  const [stations, setStations] = useState([]);
  const [menu, setMenu] = useState([]);
  const [selectedStationId, setSelectedStationId] = useState("");

  useEffect(() => {
    api.get("/stations").then((r) => setStations(r.data)).catch(() => {});
    api.get("/menu").then((r) => setMenu(r.data)).catch(() => {});
  }, []);

  const orderAt = useCallback((stationId) => {
    setSelectedStationId(stationId);
    document.getElementById("order")?.scrollIntoView({ behavior: "smooth" });
  }, []);

  return (
    <main className="bg-background" data-testid="home-page">
      <Navbar />
      <Hero />
      <Marquee />
      <Stations stations={stations} onOrder={orderAt} />
      <PnrLookup />
      <ThaliOrder
        stations={stations}
        menu={menu}
        selectedStationId={selectedStationId}
        onSelectStation={setSelectedStationId}
      />
      <Footer />
    </main>
  );
}
